import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { contentInnerStyle } from '../../dialog.vanilla.mjs';

const ContentInner = ({ className, ...props }) => {
  return /* @__PURE__ */ jsx("div", { className: classNames(className, contentInnerStyle), ...props });
};

export { ContentInner };
//# sourceMappingURL=ContentInner.mjs.map
